import { useRef, useState } from "react";
import {
  Autocomplete,
  Grid,
  TextField,
  Typography,
  ListBoxAutocomplete,
} from "../../../../components";
import { value } from "../../../../helpers";
import { ProdutosService } from "../../../../services";
import { formatPrice, timeoutBuscaAutocomplete } from "../../../../utils";

const produtosService = new ProdutosService();

const FiltroImpressaoProduto = ({
  produtoSelecionado,
  setProdutoSelecionado,
  listaOpcoesProdutos,
  setListaOpcoesProdutos,
  setFiltroImpressao,
  inputErros,
}) => {
  const inputRef = useRef();
  const [loadingAutoComplete, setLoadingAutoComplete] = useState(false);

  const buscarProdutos = (filtros, isCodBar = false) => {
    const filtro = {
      ...filtros,
      orderBy: "codigo",
      order: "asc",
      ativado: true,
      limite: 20,
    };
    produtosService.getAll(filtro).then((result) => {
      if (!result.isAxiosError) {
        const produtos = result.data.rows.map((item) => ({
          ...item,
          estoqueAtual: item.estoqueProduto?.estoque || 0,
          precoVenda: item.informacao?.precoVenda || 0,
        }));
        setListaOpcoesProdutos(produtos);

        if (produtos.length === 1 && isCodBar) {
          handleChangeAutocompleteProduto(null, produtos[0]);
        }
      } else {
        setListaOpcoesProdutos([]);
      }
      setLoadingAutoComplete(false);
    });
  };

  const onInputChangeProdutos = (event) => {
    const eventValue = event.target?.value.includes(",")
      ? event.target?.value.split(",")[0]
      : event.target?.value;
    if (
      event.key === "Backspace" &&
      inputRef.current === document.activeElement &&
      eventValue === ""
    ) {
      setListaOpcoesProdutos([]);
    }
    if (event.key === "Enter" && inputRef.current === document.activeElement) {
      setLoadingAutoComplete(true);
      const filtros = {
        codigo: eventValue,
        descricao: eventValue,
        codigoBarra: eventValue,
      };
      let isCodeBar = false;
      if (
        Number.isFinite(parseFloat(eventValue)) &&
        eventValue?.length >= 8 &&
        eventValue?.length <= 13
      ) {
        isCodeBar = true;
      }
      timeoutBuscaAutocomplete(buscarProdutos(filtros, isCodeBar));
    }
  };

  const handleChangeAutocompleteProduto = (event, value) => {
    document.getElementById("produtoId")?.blur();
    setProdutoSelecionado(value);
    setFiltroImpressao((prevState) => ({
      ...prevState,
      produtoId: value?.id,
    }));
  };

  return (
    <>
      <Grid item xs={8}>
        <Autocomplete
          required
          ListboxComponent={ListBoxAutocomplete}
          id="produtoId"
          name="produtoId"
          options={listaOpcoesProdutos}
          loading={loadingAutoComplete}
          noOptionsText="Digite e pressione Enter..."
          autoHighlight
          renderOption={(props, option) => {
            let descricaoProduto = `${option?.codigo} - ${option?.descricao}`;
            if (option?.codigoBarra) {
              descricaoProduto = `${option?.codigoBarra} - ${option?.codigo} - ${option?.descricao}`;
            }
            return option ? (
              <li {...props} style={{ background: "transparent" }}>
                <div className="d-flex justify-content-between align-items-center w-100">
                  <div>
                    <span className="fw-bold">{descricaoProduto}</span>
                    <div className="d-flex gap-3">
                      <Typography variant="body2">
                        Cód.barra: {option?.codigoBarra || "-"}
                      </Typography>
                    </div>
                    <Typography variant="body2" className="fw-bolder">
                      Estoque disponível:{" "}
                      <span
                        className={
                          option?.estoqueAtual < 0
                            ? "text-danger"
                            : "text-success"
                        }
                      >
                        {option?.estoqueAtual}
                      </span>
                    </Typography>
                  </div>
                  <div className="text-end">
                    <Typography variant="body2">Preço venda</Typography>
                    <span className="fs-6">
                      {formatPrice(option?.precoVenda || 0)}
                    </span>
                  </div>
                </div>
              </li>
            ) : (
              ""
            );
          }}
          getOptionLabel={(option) => {
            let descricaoProduto = `${option?.codigo} - ${option?.descricao}`;
            if (option?.codigoBarra) {
              descricaoProduto = `${option?.codigoBarra} - ${option?.codigo} - ${option?.descricao}`;
            }
            return option ? descricaoProduto : "";
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              label="Produto"
              margin="normal"
              required
              onKeyDown={(e) => onInputChangeProdutos(e)}
              inputRef={inputRef}
              InputProps={{
                ...params.InputProps,
              }}
              error={inputErros.get("produtoId")}
            />
          )}
          onChange={handleChangeAutocompleteProduto}
          value={value.autoComplete(
            listaOpcoesProdutos,
            produtoSelecionado?.id,
          )}
        />
      </Grid>
    </>
  );
};

export default FiltroImpressaoProduto;
